import { render, staticRenderFns } from "./requests_table.vue?vue&type=template&id=c4144f56&scoped=true"
import script from "./requests_table.vue?vue&type=script&lang=js"
export * from "./requests_table.vue?vue&type=script&lang=js"
import style0 from "./requests_table.vue?vue&type=style&index=0&id=c4144f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4144f56",
  null
  
)

export default component.exports